// extracted by mini-css-extract-plugin
export var attribution = "_99-4";
export var authorName = "_99-5";
export var quote = "_99-3";
export var testimonial = "_99-2";
export var trustedBy = "_99-0";
export var trustedByLabel = "_99-1";